import { reactive } from 'vue'

export type ToastType = 'success' | 'error' | 'warning' | 'info'

export interface ToastItem {
  id: number
  message: string
  type: ToastType
  duration: number
  paused: boolean
}

interface TimerEntry {
  timeoutId: ReturnType<typeof setTimeout>
  remaining: number
  startedAt: number
}

let _nextId = 0
const _timers = new Map<number, TimerEntry>()

export const toastState = reactive({
  toasts: [] as ToastItem[],
})

function _startTimer(id: number, remaining: number): void {
  const timeoutId = setTimeout(() => removeToast(id), remaining)
  _timers.set(id, { timeoutId, remaining, startedAt: Date.now() })
}

function _clearTimer(id: number): void {
  const t = _timers.get(id)
  if (t) { clearTimeout(t.timeoutId); _timers.delete(id) }
}

/** Adiciona um toast à fila. */
export function addToast(message: string, type: ToastType = 'info', duration = 5000): void {
  const id = _nextId++
  toastState.toasts.push({ id, message, type, duration, paused: false })
  _startTimer(id, duration)
}

/** Remove um toast (dismiss manual ou timeout). */
export function removeToast(id: number): void {
  _clearTimer(id)
  const idx = toastState.toasts.findIndex(t => t.id === id)
  if (idx > -1) toastState.toasts.splice(idx, 1)
}

/** Pausa o auto-dismiss e a barra de countdown (mouseenter). */
export function pauseToast(id: number): void {
  const t = _timers.get(id)
  if (!t) return
  clearTimeout(t.timeoutId)
  t.remaining = Math.max(0, t.remaining - (Date.now() - t.startedAt))
  const toast = toastState.toasts.find(e => e.id === id)
  if (toast) toast.paused = true
}

/** Retoma o auto-dismiss do ponto em que parou (mouseleave). */
export function resumeToast(id: number): void {
  const t = _timers.get(id)
  if (!t) return
  const toast = toastState.toasts.find(e => e.id === id)
  if (toast) toast.paused = false
  _startTimer(id, t.remaining)
}
